import { render, staticRenderFns } from "./CreateOtherModal.vue?vue&type=template&id=5b3ecd62&scoped=true&"
import script from "./CreateOtherModal.vue?vue&type=script&lang=js&"
export * from "./CreateOtherModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateOtherModal.vue?vue&type=style&index=0&id=5b3ecd62&prod&lang=scss&scoped=true&"
import style1 from "./CreateOtherModal.vue?vue&type=style&index=1&id=5b3ecd62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b3ecd62",
  null
  
)

export default component.exports